import React from 'react';
import NotificationUnreadPastFilterTabs from './unreadNotification/NotificationUnreadPastFilterTabs';
import NotificationUnreadTodayFilterTabs from './unreadNotification/NotificationUnreadTodayFilterTabs';
import NotificationUnreadYesterdayFilterTabs from './unreadNotification/NotificationUnreadYesterdayFilterTabs';

import NotificationUnreadLastMonthFilterTabs from './unreadNotification/NotificationUnreadLastMonthFilterTabs';
import NotificationUnreadLastWeekFilterTabs from './unreadNotification/NotificationUnreadLastWeekFilterTabs';
import NotificationUnreadThreeWeekAgoFilterTabs from './unreadNotification/NotificationUnreadThreeWeekAgoFilterTabs';
import NotificationUnreadTwoWeekAgoFilterTabs from './unreadNotification/NotificationUnreadTwoWeekAgoFilterTabs';

export default function NotificationUnreadFilterTabs(props) {
    // Unread
    const { UnreadvisibilityTab, notificationTabDef } = props.functionalParentCompneneLvl1;

    const handleSelectNotification = (e, notificationId, readNotificationId) => {
        props.handleSelectNotification(e, notificationId, readNotificationId);
    };

    return (
        <>
            <div className={'tab-pane ' + (notificationTabDef == 'unread' ? 'show active' : 'fade')} id="unread">
                {UnreadvisibilityTab && UnreadvisibilityTab.totalCount ? (
                    <>
                        {UnreadvisibilityTab &&
                        UnreadvisibilityTab.todayNotification &&
                        UnreadvisibilityTab.todayNotification.total > 0 ? (
                            <NotificationUnreadTodayFilterTabs
                                notificationTabDef={notificationTabDef}
                                functionalParentCompneneLvl2={props}
                                handleSelectNotification={handleSelectNotification}
                                defaultTab={UnreadvisibilityTab.defaultTodayTab}
                            />
                        ) : null}

                        {UnreadvisibilityTab &&
                        UnreadvisibilityTab.yesterdayNotification &&
                        UnreadvisibilityTab.yesterdayNotification.total > 0 ? (
                            <NotificationUnreadYesterdayFilterTabs
                                notificationTabDef={notificationTabDef}
                                functionalParentCompneneLvl2={props}
                                handleSelectNotification={handleSelectNotification}
                                defaultTab={UnreadvisibilityTab.defaultYesterdayTab}
                            />
                        ) : null}

                        {UnreadvisibilityTab &&
                        UnreadvisibilityTab.last_weekNotification &&
                        UnreadvisibilityTab.last_weekNotification.total > 0 ? (
                            <NotificationUnreadLastWeekFilterTabs
                                notificationTabDef={notificationTabDef}
                                functionalParentCompneneLvl2={props}
                                handleSelectNotification={handleSelectNotification}
                                defaultTab={UnreadvisibilityTab.defaultLastWeekTab}
                            />
                        ) : null}

                        {UnreadvisibilityTab &&
                        UnreadvisibilityTab.twoWeekNotification &&
                        UnreadvisibilityTab.twoWeekNotification.total > 0 ? (
                            <NotificationUnreadTwoWeekAgoFilterTabs
                                notificationTabDef={notificationTabDef}
                                functionalParentCompneneLvl2={props}
                                handleSelectNotification={handleSelectNotification}
                                defaultTab={UnreadvisibilityTab.defaultTwoWeekAgoTab}
                            />
                        ) : null}

                        {UnreadvisibilityTab &&
                        UnreadvisibilityTab.threeWeeNotification &&
                        UnreadvisibilityTab.threeWeeNotification.total > 0 ? (
                            <NotificationUnreadThreeWeekAgoFilterTabs
                                notificationTabDef={notificationTabDef}
                                functionalParentCompneneLvl2={props}
                                handleSelectNotification={handleSelectNotification}
                                defaultTab={UnreadvisibilityTab.defaultThreeWeekAgoTab}
                            />
                        ) : null}

                        {UnreadvisibilityTab &&
                        UnreadvisibilityTab.LastMonthNotification &&
                        UnreadvisibilityTab.LastMonthNotification.total > 0 ? (
                            <NotificationUnreadLastMonthFilterTabs
                                notificationTabDef={notificationTabDef}
                                functionalParentCompneneLvl2={props}
                                handleSelectNotification={handleSelectNotification}
                                defaultTab={UnreadvisibilityTab.defaultLastMonthTab}
                            />
                        ) : null}

                        {UnreadvisibilityTab &&
                        UnreadvisibilityTab.pastNotification &&
                        UnreadvisibilityTab.pastNotification.total > 0 ? (
                            <NotificationUnreadPastFilterTabs
                                notificationTabDef={notificationTabDef}
                                functionalParentCompneneLvl2={props}
                                handleSelectNotification={handleSelectNotification}
                                defaultTab={UnreadvisibilityTab.defaultPastTab}
                            />
                        ) : null}
                    </>
                ) : (
                    <>
                        <div className="no-notification">No unread notifications.</div>
                    </>
                )}
            </div>
        </>
    );
}
